import * as angular from 'angular';

export class FormVerificationService {
    private toastr;

    constructor(toastr) {
        this.toastr = toastr;
    }

    error(errFromBackend, form) {
        this.clearErrors(form);
        this.setErrors(errFromBackend, form);
    }

    setErrors(errFromBackend, form) {
        if (typeof errFromBackend === 'string') {
            return;
        }
        for (let key in errFromBackend) {
            if (Array.isArray(errFromBackend[key])) {
                for (let subKey in errFromBackend[key]) {
                    if (typeof errFromBackend[key][subKey] === 'string') {
                        this.toastr.error(errFromBackend[key][subKey]);

                        if (form[key]) {
                            form[key].$setValidity('error_field', true);
                        }
                    } else {
                        this.setErrors(errFromBackend[key][subKey], form);
                    }
                }
            } else {
                this.setErrors(errFromBackend[key], form);
            }
        }
    }

    clearErrors(form) {
        angular.forEach(form, function (value, key) {
            if (key[0] !== '$') {
                form[key].$setValidity('error_field', null);
            }
        });
    }
}

angular
    .module('app')
    .service('FormVerificationService', FormVerificationService);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/form_verification.service.ts